import { LINE_BY_ID, type LineId } from '../data/map'

interface Props {
  line: string
  /** 1 = base share, 2/3 = +¥300/+¥600 surcharge per rulebook. */
  order: 1 | 2 | 3
  size?: 'sm' | 'md'
}

/**
 * Compact stock-card chip rendered programmatically — line letter +
 * line colour + share-order surcharge. Used in the player strip and
 * results screen so a player's portfolio reads at a glance.
 */
export function StockCardChip({ line, order, size = 'sm' }: Props) {
  const def = LINE_BY_ID[line as LineId]
  const colour = def?.color ?? '#888'
  const padding = size === 'sm' ? 'px-1.5 py-0.5' : 'px-2 py-1'
  const text = size === 'sm' ? 'text-[10px]' : 'text-xs'
  const surcharge = order === 1 ? null : order === 2 ? '+¥300' : '+¥600'

  return (
    <span className={`inline-flex items-center gap-1 ${padding} ${text} rounded
                      bg-white border border-black/10 shadow-xs font-bold`}>
      <span className="w-2 h-2 rounded-full shrink-0" style={{ backgroundColor: colour }} />
      <span style={{ color: colour }}>{line}</span>
      <span className="text-brand-text">#{order}</span>
      {surcharge && <span className="text-brand-muted text-[9px]">{surcharge}</span>}
    </span>
  )
}
